<template>
  <v-container class='confirmarPage'>
    <h1 class='confirmarTitle'>Confirmación del registro</h1>
    <v-card width='500' class='mx-auto'>
      <v-card-title class='formTitle'>Introduce el código para activar tu cuenta</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols='12' sm='8'>
              <v-text-field
                v-model='codigo'
                label='Código'
                outlined
                @keydown='onKeyDown($event)'
                @input='onInput($event)'
                ref='codigo'
                :key='key'
              ></v-text-field>
            </v-col>
            <v-col cols='12' sm='4' class='text-center'>
              <v-btn
                @click='activarUsuario'
                color='primary'
                :disabled='!ready'
              >Activar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import { ApiInit } from '@/api';
  import { consoleErrorMessage, toasterErrorMessage } from '@/utils/responseCatchMessages.js';
  import { incompleteQuery } from '@/utils/checkQuery.js';
  export default {
    data() {
      return {
        codigo: '',
        userId: 0,
        awaitingResponse: true,
        resetValue: false,
        inputBuffer: '',
        cursorPositionBuffer: 0,
        key: 0,
      }
    },
    computed: {
      ready() {
        if (this.awaitingResponse) return false;
        if (!this.validCode) return false;
        return true;
      },
      validCode() {
        if (!/^\d{8}$/.test(this.codigo)) return false;
        return true;
      },
    },
    mounted() {
      ApiInit().then(r => this.init());
    },
    methods: {
      init() {
        const query = this.$route.query;
        const requiredParams = ['u'];
        if (!incompleteQuery(query, requiredParams)) {
          this.userId = query.u;
          this.awaitingResponse = false;
        }
      },
      async activarUsuario() {
        const defaultToastMessage = 'Error al confirmar usuario.';
        const defaultConsoleMessage = 'activarUsuario error';
        try {
          const token = this.codigo;
          const userId = this.userId;
          this.awaitingResponse = true;
          const response = await this.$store.dispatch('confirmarUsuario', {userId, token});
          if (response === null) {
            console.error(defaultConsoleMessage);
            this.$toast.error(defaultToastMessage);
            this.stopWait();
            return;
          }
          this.$toast.success('Información enviada exitosamente.<br>Redirigiendo a login.');
          let self = this;
          window.setTimeout((obj) => (obj.$router.push({name:'Login'})), 1000, self)
        } catch (e) {
          consoleErrorMessage(e, defaultConsoleMessage);
          toasterErrorMessage(this.$toast.error, e, defaultToastMessage);
          this.stopWait();
        }
      },
      stopWait() {
        var self = this;
        window.setTimeout((obj) => { obj.awaitingResponse = false; }, 500, self);
      },
      onKeyDown(event) {
        this.inputBuffer = this.codigo;
        if (event.key.length > 1) return;
        if (!/^[\dxcv]$/.test(event.key)) event.preventDefault();
      },
      onInput(event) {
        this.resetValue = false;
        const val = this.getCodeFromText(event);
        if (/^\d{0,8}$/.test(val) && this.codigo !== val) {
          this.inputBuffer = val;
          this.resetValue = true;
        }
        if (!/^\d{0,8}$/.test(event)) this.resetValue = true;
        if (this.resetValue) {
          const diff = this.codigo.length - this.inputBuffer.length;
          this.cursorPositionBuffer = this.$refs.codigo.$refs.input.selectionEnd - diff;
          this.codigo = this.inputBuffer;
          this.key++;
        }
      },
      getCodeFromText(text) {
        const arr = text.match(/\d+/g);
        if (arr === null) return text;
        let max = 0;
        let retIndex = -1;
        for (const index in arr) {
          if (arr[index].length === 8) return arr[index];
          if (arr[index].length > max) {
            max = arr[index].length;
            retIndex = index;
          }
        }
        if (retIndex !== -1) return arr[retIndex];
        return text;
      },
    },
    updated() {
      if (this.resetValue) {
        this.resetValue = false;
        this.$refs.codigo.focus();
        this.$refs.codigo.$refs.input.selectionEnd = this.cursorPositionBuffer;
      }
    },
  };
</script>

<style scoped>
  .confirmarPage {}
  .confirmarTitle {
    margin: 30px;
    text-align: center;
  }
  .formTitle {
    margin: 20px;
    padding-top: 30px;
  }
</style>